import React from "react";
import styles from "./ListingCard.module.css";
import Button from '@mui/material/Button';
import CircleIcon from '@mui/icons-material/Circle';
//import Img from '../../../../assets/imgs/CourseIcon.png';


{/* <ListingCard
  LineStatus={false}
  IconStatus={true}
  Icon={Img}
  Title="Imam Mohammad Ibn Saud Islamic Univers..."
  Description="What is islamic finance?"
  ChipStatus={false}
  StatusColor="#FA0"
  ChipLabel="Pending"
  ButtonStatus={true}
  ButttonLabel="Following"
  Link="#"
/> */}


function ListingCard(props) {


  return (
    <div className={styles.ListingCard} style={{ background:props.SelectedBackground }} onClick={props.onClick}>
      <div className={styles.ListingCardLeftCol}>
        {props.IconStatus &&
          <div className={styles.ListingCardIcon}><img src={props.Icon} /></div>
        }
        {props.LineStatus &&
          <div className={styles.ListingCardStatusLine} style={{ background: props.StatusColor, opacity: "15%", }}></div>
        }
        <div className={styles.ListingCardContent}>
          <div>
            <div className={styles.ListingCardTitle}>
              {props.Title}
            </div>
            <div className={styles.ListingCardDescription}>{props.Description}</div>
            {props.DateTitmeStatus &&
            <div className={styles.ListingCardDateTime}>{props.Date} <CircleIcon /> {props.Time}  </div>
          }
          </div>
        </div>
      </div>

      <div className={styles.ListingCardRightCol}>
        {props.ChipStatus &&
          <div className={styles.ListingCardSatusChip}>
            <div className={styles.ListingCardSatusChipLine} style={{ background: props.StatusColor, }}></div>
            <div className={styles.ListingCardSatusChipBg} style={{ background: props.StatusColor, opacity: "15%", }}></div>
            <span>{props.ChipLabel}</span>
          </div>
        }
        {props.ButtonStatus &&
          <div className={styles.ListingCardButton}>
            <Button variant="text" href={props.Link}>{props.ButttonLabel}</Button>
          </div>
        }
      </div>
    </div>
  );
}


export default ListingCard;

